import { Button, Form, message, Modal, Radio, Upload } from "antd";
import { InboxOutlined, PlusOutlined } from "@ant-design/icons";
import { useState } from "react";
import { BrokerSelect } from "../negotiationForm/selects";
import { useStatementDocumentUploader } from "../../hooks/useStatementDocumentUploader";

const { Dragger } = Upload;

export const CreateReconciliationModal = () => {
  const [form] = Form.useForm();

  const [upload, { isLoading }] = useStatementDocumentUploader();
  const broker = Form.useWatch("broker", form);
  const files = Form.useWatch("files", form);

  const [open, setOpen] = useState(false);
  return (
    <>
      <Modal
        title={"Aggiungi estratto conto"}
        open={open}
        onCancel={() => {
          form.resetFields();
          setOpen(false);
        }}
        okText={"Aggiungi"}
        onOk={() => {
          form.validateFields().then((values) => {
            upload(values.broker, values.files[0].originFileObj, values.to_be_reconciled)
              .then(() => {
                message.success("Documento salvato");
                form.resetFields();
                setOpen(false);
              }).catch((err) => {
              console.error(err);
              message.error(err);
            });
          }).catch(err => {
            console.error("validation error", err);
          });
        }}
        okButtonProps={{ disabled: isLoading || !(broker && files), loading: isLoading }}>
        <Form form={form} layout={"vertical"} initialValues={{to_be_reconciled: true}}>
          <BrokerSelect
            fieldName={"broker"}
            label={"Broker"}
            isReconciliationBrokers={true}
            rules={[{ required: true, message: "Il campo broker è obbligatorio" }]}
            showCreationDialog={false} />
          <Form.Item
            name={"files"}
            label={"Carica file"}
            valuePropName={"fileList"}
            getValueFromEvent={(e) => e.fileList}
            rules={[
              {
                required: true,
                message:
                  "I documenti di cui effettuare l'estrazione sono obbligatori"
              }
            ]}
          >
            <Dragger
              beforeUpload={() => false}
              multiple={false}
              maxCount={1}
              accept={".pdf,.xls,.xlsx"}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Trascina il file qui o clicca per caricare
              </p>
              <p className="ant-upload-hint">
                Supporta solo file PDF, Excel
              </p>
            </Dragger>
          </Form.Item>
          <Form.Item
            label={"L'estratto conto è riconciliabile?"}
            rules={[{required: true, message: "Questo campo è obbligatorio"}]}
            name={"to_be_reconciled"}>
            <Radio.Group options={[{value: true, label: "Sì"},{value: false, label: "No"}]}/>
          </Form.Item>
        </Form>
      </Modal>
      <Button type={"link"} icon={<PlusOutlined />} onClick={() => setOpen(true)}>Aggiungi estratto conto</Button>
    </>
  );
};